import React, { useState } from "react";
import PropTypes from "prop-types";

import Hamburger from "src/components/header-new/hamburger";

import {
  DEFAULT_PRIMARY_BUTTON,
  LandingLink,
  LandingLogo,
  normalizeMenuItems,
} from "../shared/nav";
import useBodyScrollLock from "../shared/useBodyScrollLock";

import "./styles.css";

const BASE_CLASS = "landing_layout_header";

const HeaderUpdatesIcon = () => (
  <svg
    className="landing_layout_header__updates_icon"
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="25.5" cy="25.5" r="25" fill="#2A464A" stroke="#2CC486" />
    <g clipPath="url(#landing_header_updates_icon_clip)">
      <path
        d="M34.3352 27.9703L33.2405 27.3383C33.3374 26.8668 33.3835 26.4312 33.3835 26C33.3835 25.5688 33.3374 25.1332 33.2405 24.6617L34.3353 24.0296C34.5237 23.9208 34.6612 23.7417 34.7175 23.5316C34.7738 23.3214 34.7443 23.0975 34.6355 22.9091L32.9949 20.0674C32.7683 19.6751 32.2667 19.5406 31.8744 19.7672L30.7895 20.3935C30.1095 19.8167 29.3203 19.3659 28.4616 19.0639V17.7969C28.4616 17.3438 28.0944 16.9766 27.6413 16.9766H24.3601C23.907 16.9766 23.5398 17.3438 23.5398 17.7969V19.0639C22.6811 19.3659 21.8918 19.8168 21.2119 20.3935L20.127 19.7672C19.7347 19.5406 19.233 19.6751 19.0065 20.0674L17.3659 22.9091C17.2571 23.0975 17.2277 23.3214 17.284 23.5315C17.3403 23.7416 17.4777 23.9208 17.6661 24.0296L18.7609 24.6617C18.6639 25.1332 18.6178 25.5688 18.6178 26C18.6178 26.4312 18.6639 26.8668 18.7608 27.3383L17.666 27.9704C17.4776 28.0792 17.3401 28.2583 17.2838 28.4684C17.2275 28.6786 17.257 28.9025 17.3658 29.0909L19.0064 31.9326C19.233 32.325 19.7347 32.4594 20.1269 32.2328L21.2118 31.6065C21.8918 32.1833 22.681 32.6341 23.5397 32.9361V34.2031C23.5397 34.6562 23.9069 35.0234 24.36 35.0234H27.6412C28.0943 35.0234 28.4615 34.6562 28.4615 34.2031V32.9361C29.3202 32.6341 30.1095 32.1832 30.7894 31.6065L31.8743 32.2328C32.2666 32.4594 32.7682 32.3249 32.9948 31.9326L34.6354 29.0909C34.6893 28.9977 34.7243 28.8947 34.7384 28.7879C34.7524 28.6811 34.7453 28.5725 34.7175 28.4685C34.6896 28.3644 34.6415 28.2668 34.5759 28.1814C34.5103 28.0959 34.4285 28.0242 34.3352 27.9703ZM26.0007 28.4609C24.6437 28.4609 23.5397 27.357 23.5397 26C23.5397 24.643 24.6437 23.5391 26.0007 23.5391C27.3576 23.5391 28.4616 24.643 28.4616 26C28.4616 27.357 27.3576 28.4609 26.0007 28.4609Z"
        fill="white"
      />
      <path
        d="M37.2191 17.62L36.059 14.1396C35.9157 13.7099 35.4511 13.4775 35.0214 13.6208C34.5916 13.7641 34.3593 14.2286 34.5025 14.6585L34.6011 14.9543C33.8613 14.3911 33.0696 13.8994 32.2367 13.486C30.2768 12.5138 28.1202 12 26 12C22.2807 12 18.7706 13.4618 16.1163 16.1163C13.4618 18.7706 12 22.2808 12 26C12 27.7177 12.3609 29.4775 13.0725 31.2305C13.2019 31.5492 13.5088 31.7424 13.8328 31.7424C13.9356 31.7424 14.0401 31.723 14.1411 31.682C14.5609 31.5116 14.763 31.0331 14.5926 30.6133C13.9609 29.0573 13.6406 27.5052 13.6406 26C13.6406 19.185 19.185 13.6406 26 13.6406C28.5014 13.6406 31.0265 14.4728 33.1245 15.916C32.7235 15.8336 32.3151 16.0617 32.1824 16.4598C32.0391 16.8895 32.2714 17.3541 32.7012 17.4974L36.1815 18.6575C36.326 18.7057 36.4811 18.7126 36.6293 18.6776C36.7776 18.6426 36.9131 18.567 37.0209 18.4593C37.1286 18.3516 37.2042 18.216 37.2392 18.0678C37.2742 17.9195 37.2672 17.7645 37.2191 17.62ZM38.9275 20.7695C38.7571 20.3497 38.2785 20.1477 37.8589 20.318C37.4391 20.4884 37.237 20.9669 37.4074 21.3867C38.0391 22.9427 38.3594 24.4948 38.3594 26C38.3594 32.815 32.815 38.3594 26 38.3594C23.4986 38.3594 20.9735 37.5273 18.8755 36.084C19.2764 36.1663 19.6849 35.9384 19.8176 35.5402C19.9609 35.1105 19.7286 34.6459 19.2988 34.5026L15.8185 33.3425C15.674 33.2942 15.5189 33.2873 15.3706 33.3222C15.2223 33.3572 15.0867 33.4328 14.979 33.5406C14.8712 33.6483 14.7956 33.7839 14.7606 33.9322C14.7257 34.0805 14.7327 34.2356 14.7809 34.3801L15.9409 37.8604C16.0556 38.2042 16.3755 38.4216 16.7191 38.4216C16.8051 38.4216 16.8926 38.4079 16.9786 38.3793C17.4084 38.236 17.6406 37.7715 17.4974 37.3416L17.3988 37.0458C18.1387 37.609 18.9304 38.1007 19.7632 38.5141C21.7232 39.4862 23.8798 40 26 40C29.7193 40 33.2294 38.5382 35.8837 35.8837C38.5382 33.2294 40 29.7192 40 26C40 24.2823 39.6391 22.5225 38.9275 20.7695Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="landing_header_updates_icon_clip">
        <rect width="28" height="28" fill="white" transform="translate(12 12)" />
      </clipPath>
    </defs>
  </svg>
);

const LandingLayoutHeader = ({ settings, solid }) => {
  const [menuVisibility, setMenuVisibility] = useState(null);
  const menuItems = normalizeMenuItems(settings?.menuItems);
  const primaryButton = settings?.primaryButton?.url
    ? settings.primaryButton
    : DEFAULT_PRIMARY_BUTTON;
  const updatesButton = settings?.updatesButton?.url
    ? settings.updatesButton
    : null;
  const logo = settings?.headerLogo || settings?.footerLogo;

  useBodyScrollLock(menuVisibility === "active");

  const closeMenu = () => setMenuVisibility(null);
  const toggleMenu = () =>
    setMenuVisibility((current) => (current === "active" ? null : "active"));

  return (
    <header
      className={`landing_layout_header${
        solid ? " landing_layout_header--solid" : ""
      }`}
    >
      <div className="landing_container landing_layout_header__container">
        <LandingLogo logo={logo} baseClass={BASE_CLASS} />

        <nav className="landing_layout_header__nav" aria-label="Landing menu">
          {menuItems.map((item) => (
            <LandingLink item={item} key={`${item.title}-${item.url}`} />
          ))}
        </nav>

        <div className="landing_layout_header__actions">
          {updatesButton && (
            <LandingLink
              item={updatesButton}
              className="landing_layout_header__updates_link"
            >
              <HeaderUpdatesIcon />
              {updatesButton.title}
            </LandingLink>
          )}
          <LandingLink
            item={primaryButton}
            className="landing_layout_header__button"
            track={{
              action: "Download Plugin",
              category: "Plugin",
              label: "Header",
            }}
          />
        </div>

        <button
          className="landing_layout_header__menu_btn"
          type="button"
          aria-label="Toggle menu"
          aria-expanded={menuVisibility === "active"}
          onClick={toggleMenu}
        >
          <Hamburger menuVisibility={menuVisibility} />
        </button>
      </div>

      <div className={`landing_layout_header__mobile_menu ${menuVisibility || ""}`}>
        <div className="landing_layout_header__mobile_inner">
          <LandingLogo logo={logo} baseClass={BASE_CLASS} />

          <nav aria-label="Mobile landing menu">
            {menuItems.map((item, index) => (
              <LandingLink
                item={item}
                key={`${item.title}-${item.url}`}
                onClick={closeMenu}
                style={{ "--d": `${index * 80 + 240}ms` }}
              />
            ))}
          </nav>

          {updatesButton && (
            <LandingLink
              item={updatesButton}
              className="landing_layout_header__mobile_updates_link"
              onClick={closeMenu}
            >
              <HeaderUpdatesIcon />
              {updatesButton.title}
            </LandingLink>
          )}

          <LandingLink
            item={primaryButton}
            className="landing_layout_header__mobile_button"
            onClick={closeMenu}
            track={{
              action: "Download Plugin",
              category: "Plugin",
              label: "Header Mobile",
            }}
          />
        </div>
      </div>
    </header>
  );
};

LandingLayoutHeader.propTypes = {
  settings: PropTypes.shape({
    footerLogo: LandingLogo.shape,
    headerLogo: LandingLogo.shape,
    menuItems: PropTypes.array,
    primaryButton: LandingLink.shape,
    updatesButton: LandingLink.shape,
  }),
  // When true, the header gets a solid background instead of being transparent.
  // Used on light-background pages (e.g. legal pages) where the white logo and
  // links would otherwise be invisible over the hero.
  solid: PropTypes.bool,
};

LandingLayoutHeader.defaultProps = {
  settings: null,
  solid: false,
};

export default LandingLayoutHeader;
